<form [formGroup]="form" (ngSubmit)="submitted.next()" novalidate>
  <div class="gmb-8">
    <div class="w-100 gmb-16 gmb-sm-0 d-inline-flex">
      <gpu-form-field
        [appearance]="formFieldAppearance"
        class="gpu-wrapper-reserved"
      >
        <gpu-label *ngIf="configuration.measurementMetrics[0] as metric">
          {{ metric.name }} ({{ metric.units[0].name }})
        </gpu-label>
        <input
          id="value"
          name="value"
          type="text"
          gpuInput
          [focused]="true"
          gpuLocalNumber
          [placeholder]="'ANALYSES.SINGLE.VALUE' | translate"
          formControlName="value"
          (blur)="trackInput($event, configuration.measurementMetrics[0].id)"
        />
        <gpu-error
          *ngIf="
            form.controls.value.errors?.required &&
            !form.controls.value.errors?.invalidValue
          "
        >
          {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.pattern">
          {{ 'ANALYSES.VALUE_INVALID' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.min">
          {{ 'MIN_VALUE' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.max">
          {{ 'MAX_VALUE' | translate }}
        </gpu-error>
      </gpu-form-field>
    </div>
  </div>

  <gpu-form-field [appearance]="formFieldAppearance">
    <gpu-label>
      {{ 'ANALYSES.ADD.DATE' | translate }}
    </gpu-label>
    <input
      id="value-date"
      name="date"
      type="text"
      gpuDatepicker
      ngbDatepicker
      #datepicker="ngbDatepicker"
      container="body"
      formControlName="date"
      [maxDate]="now"
      [minDate]="minDate"
      [datepicker]="datepicker"
      [placeholder]="'ANALYSES.ADD.DATE' | translate"
    />
    <i gpuSuffix class="gpicon-calendar"></i>
    <gpu-error *ngIf="form.controls.date?.errors?.required">
      {{ 'ANALYSES.ADD.REQUIRED' | translate }}
    </gpu-error>
  </gpu-form-field>

  <app-measurement-add-buttons
    [formValid]="form.valid"
    [editMode]="editMode"
    [isLoading]="false"
  ></app-measurement-add-buttons>
</form>
